import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Card, Form, Button, Input } from "antd";
import { withRouter } from "react-router";
import DateRangePicker from "../../common/date-range-picker";
import MultiSelect from "../../common/multi-select";
import FullTextHelp from "../../common/full-text-help";
import { isEqual } from "lodash";
import { keepOnlyRepoIetfQueryStrings } from "../../../helpers/url";
import { getDistinctValues } from "../../../services/api-repo";

const propsToStates = q => ({
  fullText: q.full_text,
  source: q.source,
  authors: q.authors,
  uploadDate: q.upload_date
});

class ToolbarIETF extends Component {
  static propTypes = {
    accessLevel: PropTypes.string,
    esUrl: PropTypes.string
  };
  state = {
    ...propsToStates(keepOnlyRepoIetfQueryStrings(this.props.location.query))
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.location.query, nextProps.location.query)) {
      this.setState(propsToStates(keepOnlyRepoIetfQueryStrings(nextProps.location.query)));
    }
  }

  render() {
    const { accessLevel } = this.props;
    const fullTextLabel = (
      <span>
        {"FULL TEXT "}
        <FullTextHelp />
      </span>
    );
    const resetButton = (
      <Button size="small" onClick={this._resetFilter}>
        {"Reset"}
      </Button>
    );
    const toolbarTitle = (
      <div>
        <p style={{ margin: 0 }}>IETF</p>
        <p style={{ margin: 0 }}>Standardization</p>
      </div>
    );

    return (
      <Card title={toolbarTitle} extra={resetButton}>
        <Form layout="vertical">
          <Form.Item label={fullTextLabel}>
            <Input
              placeholder="Full Text Search"
              onChange={e => this.setState({ fullText: e.target.value })}
              onPressEnter={this._updateRouter}
              value={this.state.fullText}
              disabled={accessLevel !== "full"}
            />
            {accessLevel !== "full" ? <Link to={{ pathname: "/standards/open/ietf", query: { full_text: "example" } }}> {"Example"} </Link> : null}
          </Form.Item>
          {this._renderSelectFormItem("source", "SOURCE", false, "e.g. Intel")}
          {this._renderSelectFormItem("authors", "AUTHOR", false, "e.g. Dorothy Stanley")}
          {this._renderDateFormItem("uploadDate", "UPLOAD DATE", false)}
        </Form>
      </Card>
    );
  }

  _renderSelectFormItem = (key, label, disabled, placeholder, options, valueRenderer, mode) => {
    const fieldES = {
      source: "source",
      authors: "authors"
    }[key];
    return (
      <Form.Item label={label}>
        <MultiSelect
          value={this.state[key]}
          onChange={this._updateState(key)}
          options={options}
          optionApiCall={
            options
              ? undefined
              : val =>
                getDistinctValues(this.props.esUrl, fieldES, {
                  [fieldES]: val || ""
                })
          }
          optionRender={valueRenderer}
          placeholder={placeholder}
          disabled={disabled}
          mode={mode}
        />
      </Form.Item>
    );
  };

  _renderDateFormItem = (key, label, disabled) => {
    return (
      <Form.Item label={label}>
        <DateRangePicker value={this.state[key]} onChange={this._updateState(key)} disabled={disabled} />
      </Form.Item>
    );
  };

  _resetFilter = () => {
    this.setState(
      {
        fullText: undefined,
        source: undefined,
        authors: undefined,
        uploadDate: undefined
      },
      this._updateRouter
    );
  };

  _runAfterTyping = (func, interval = 800) => {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeout = setTimeout(func, interval);
  };

  _updateState = field => {
    return val => {
      this.setState({ [field]: val }, this._updateRouter);
    };
  };

  _updateRouter = () => {
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: {
        full_text: this.state.fullText,
        source: this.state.source,
        authors: this.state.authors,
        upload_date: this.state.uploadDate
      }
    });
  };
}

export default withRouter(ToolbarIETF);
